import { InjectionToken } from '@angular/core';

/**
 * Flag, ob ausschließlich der native Scanner (Texteingabe) genutzt werden soll.
 * Die App überschreibt den Token mit dem Wert aus dem Funktionsschalter; Default ist false.
 */
export const SCANNER_ONLY_NATIVE = new InjectionToken<boolean>('SCANNER_ONLY_NATIVE', {
  providedIn: 'root',
  factory: () => false,
});
